// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_p8-0";